import Navbar from "../components/navbar";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";

import Hero from "../components/Hero";
import ContactImg from "../assets/contact.jpg";
function Contact() {
  return (
    <>
      <Navbar />
      <Hero cName="hero-mid" heroImg={ContactImg} title="Contact" btnClass="hide" />
      <ContactForm/>
      <Footer/>
    </>
  );
}

export default Contact;
